declare global {
  interface ImportMetaEnv {
    VITE_ITC_API_ORIGIN: string;
  }
}

export const config = {
  ITC_API_ORIGIN: import.meta.env.VITE_ITC_API_ORIGIN,
};
